import { DragIcon } from 'assests/GmsIcons';
import React, { useEffect, useState } from 'react';
import ToggleEyeButton from './ToggleEyeButton';
import { CONNECTOR } from 'Pages/GMS/ISR/ISRConstants';
import { TConnector } from '../ui';
import { colorTheme } from '../ColorTheme';

type TUIConnectorItemProps = {
    connector: TConnector;
    connectorIndex: number;
    updateConnector: (connector: TConnector, connectorIndex: number) => void;
    dragHandleProps?: any;
}

const UIConnectorItem = ({connector, updateConnector, connectorIndex, dragHandleProps}: TUIConnectorItemProps) => {
    const [connectorField, setConnectorField] = useState<TConnector>();

    const handleHiddenChange = () => {
        setConnectorField((prevCategoryField) => ({
            ...prevCategoryField!,
            isConnectorVisible: !prevCategoryField?.isConnectorVisible,
        }));
    }

    useEffect(() => {
        if (connectorField) {
            updateConnector(connectorField, connectorIndex);
        }
    }, [connectorField]);

    useEffect(() => {
        setConnectorField(connector);
    }, []);

    return (
        <div className='tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[104px] tw-border-[2px] tw-border-solid tw-border-[#f4f4f7] tw-mt-2'>
            <div className="tw-flex tw-items-center tw-justify-between tw-rounded-t tw-rounded-b-none tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[38px] tw-border-[1px] tw-border-solid tw-border-[#dadbdd] tw-px-3">
                <div className="tw-flex tw-items-center tw-gap-3">
                    {/* <DragIcon /> */}
                    <div {...dragHandleProps}>
                        <DragIcon />
                    </div>
                    <label className="tw-text-[#090A42] tw-text-sm tw-ml-4"
                        style={{color: colorTheme.title}}
                    >{connector?.connectorName ?? ''}</label>
                </div>
                <div className="tw-flex tw-items-center tw-gap-3">
                    <ToggleEyeButton isClicked={connectorField?.isConnectorVisible ?? false} onClick={handleHiddenChange} />
                    {/* <DeleteIcon /> */}
                </div>
            </div>
            <div className='tw-flex tw-justify-between tw-text-center tw-items-center tw-mt-2.5'>
                <div className="tw-rounded tw-bg-[#f4f4f7] tw-box-border tw-w-[440px] tw-flex tw-flex-row tw-items-center tw-justify-start tw-py-2 tw-px-2.5 tw-gap-[10px] tw-text-sm tw-border-[1px] tw-border-solid tw-border-[#ebecf0] tw-ms-3"
                    style={{backgroundColor: colorTheme.background}}
                >{connector?.connectorName ?? ''}</div>
                    <div className='tw-flex tw-me-3'>
                        <input disabled={true} placeholder={CONNECTOR}  className="tw-rounded tw-bg-shades-of-grey-20 tw-box-border tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-py-2 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"/>
                    </div>
            </div>
        </div>
    );
}

export default UIConnectorItem;